// Şəkli brauzerdə sıxır: ölçünü kiçildir + JPEG keyfiyyətini addım-addım azaldır,
// nəticə targetBytes-dan kiçik olana qədər. Onsuz da kiçik və ölçüsü uyğun olan fayla toxunmur.
// Qaytarır: File (yükləməyə hazır). Şəkil oxuna bilmirsə xəta atır.

const loadImage = (file) => new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Şəkil oxunmadı. JPG, PNG və ya WEBP seçin.')); };
    img.src = url;
});

const canvasToBlob = (canvas, quality) => new Promise((resolve) => {
    canvas.toBlob((b) => resolve(b), 'image/jpeg', quality);
});

export const compressImage = async (file, {
    maxWidth = 1440,
    maxHeight = 2560,
    targetBytes = 1.5 * 1024 * 1024,
} = {}) => {
    const img = await loadImage(file);
    let w = img.naturalWidth || img.width;
    let h = img.naturalHeight || img.height;

    // Artıq kiçikdir və ölçüləri limit daxilindədir → olduğu kimi
    if (file.size <= targetBytes && w <= maxWidth && h <= maxHeight) return file;

    const fit = Math.min(1, maxWidth / w, maxHeight / h);
    w = Math.round(w * fit);
    h = Math.round(h * fit);

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Ölçünü 4 dəfəyə qədər kiçildib keyfiyyəti azaldaraq hədəfə çatmağa çalış
    for (let pass = 0; pass < 4; pass += 1) {
        canvas.width = w;
        canvas.height = h;
        ctx.fillStyle = '#ffffff'; // şəffaf PNG → JPEG-də qara fon olmasın
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0, w, h);

        for (const q of [0.85, 0.75, 0.65, 0.55]) {
            const blob = await canvasToBlob(canvas, q);
            if (blob && blob.size <= targetBytes) {
                const name = String(file.name || 'image').replace(/\.[^.]+$/, '') + '.jpg';
                return new File([blob], name, { type: 'image/jpeg' });
            }
        }
        w = Math.round(w * 0.8);
        h = Math.round(h * 0.8);
    }
    throw new Error('Şəkli kifayət qədər sıxmaq alınmadı. Başqa şəkil seçin.');
};

export default compressImage;
